export default __webpack_public_path__ + "static/received_1053940191913845-46f2c061de5a92824e84c584ac8a3486.webp";